import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { AddCircle, Visibility } from "@mui/icons-material";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import TableComponent from "../../../../../TableComponent/TableComponent";
import { getChokingAssessments } from "../../../../../../api/services/assessment";
import { formatDateField } from "../../../../../../base/FormatTime";
import { QK } from "../../../../../../base/qk";
import CreateChokingAssessmentModal from "./CreateChockingAssessmentModal";
import ChokingAssessmentDetailsModal from "./ChockingAssessmentDetailsModal";

const ChokingAssessment = () => {
  const { id: clientID } = useParams();
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const { data: chokingAssessments, isLoading } = useQuery(
    [QK.chokingAssessments, clientID],
    () => getChokingAssessments(clientID),
    { enabled: !!clientID }
  );

  const handleShowDetailsModal = (assessment) => {
    setSelectedAssessment(assessment);
    setShowDetailsModal(true);
  };

  const columns = [
    {
      field: "created_at",
      headerName: "Date",
      render: (value) => formatDateField(value),
    },
    { field: "client_name", headerName: "Service User" },
    { field: "created_by_name", headerName: "Created By" },
    { field: "care_plan_name", headerName: "Care Plan" },
    { field: "summary", headerName: "Summary" },
  ];

  const actions = [
    {
      icon: <Visibility />,
      color: "primary",
      handler: (assessment) => handleShowDetailsModal(assessment),
    },
  ];

  return (
    <div className="w-75 mx-auto">
      <Card sx={{ mb: 3 }}>
        <Box sx={{ bgcolor: "white", color: "black", p: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Typography variant="h5">Choking Risk Assessment</Typography>
            <Button
              variant="contained"
              startIcon={<AddCircle />}
              color="primary"
              onClick={() => setShowCreateModal(true)}
            >
              New Assessment
            </Button>
          </Stack>
        </Box>
      </Card>
      <div>
        <TableComponent
          data={chokingAssessments || []}
          columns={columns}
          actions={actions}
          isLoading={isLoading}
          size="small"
        />
      </div>
      <CreateChokingAssessmentModal
        open={showCreateModal}
        handleClose={() => setShowCreateModal(false)}
      />
      <ChokingAssessmentDetailsModal
        open={showDetailsModal}
        handleClose={() => setShowDetailsModal(false)}
        assessment={selectedAssessment}
      />
    </div>
  );
};

export default ChokingAssessment;
